"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

/**
 * Triangle Icon Component
 *
 * Tree-shakeable icon component for triangle/arrow indicators.
 *
 * @example
 * ```tsx
 * import Triangle from '@insided/destination/icons/Triangle'
 *
 * <Triangle width={10} height={8} />
 * ```
 */
var Triangle = function Triangle(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    "aria-hidden": "true",
    width: 24,
    height: 24,
    viewBox: "0 0 10 8",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Triangle",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M0 8L5 0L10 8H0Z",
    fill: "currentColor"
  }));
};

var _default = Triangle;
exports.default = _default;